import { trim } from "lodash";
import { AiccLessonEntryPayload } from "types/model/aiccLearningAssets";

export function toLessonEntryPayload(values: AiccLessonEntryPayload): AiccLessonEntryPayload {
  return {
    level: values.level,
    lesson: values.lesson,
    text: trim(values.text),
    translation: trim(values.translation),
    transliteration: trim(values.transliteration) || undefined,
  };
}
